<template>
    <page-layout :nav-items="[]" :side-items="sideitems" />
</template>
<script>
export default {
    data() {
        return {
            sideitems: []
        }
    }
}
</script>